export default __webpack_public_path__ + "static/media/ellipse_1.6dc4ea0a.svg";